import React from 'react';
export const PersonalHome = React.lazy(() => import('./PersonalHome'));
